import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { theme } from '../../../../common/styles/theme';
import { EndlessBookIcon } from '../../../../../icons/EndlessBookIcon';

// "This lesson has a book" pill next to ExercisesProgress; opens the Book tab.
export const BookChip: React.FC<{
	onOpen?: () => void;
}> = ({ onOpen }) => (
	<Tooltip
		title={'Open the book'}
		placement={'top'}
		enterDelay={500}
		disableInteractive
	>
		<Box
			component={'button'}
			onClick={(e: React.MouseEvent) => {
				// not the tile's own click (opens the recording)
				e.stopPropagation();
				onOpen?.();
			}}
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: .5,
				flexShrink: 0,
				px: 1,
				border: 'none',
				borderRadius: 999,
				lineHeight: '20px',
				fontFamily: 'inherit',
				fontWeight: 500,
				fontSize: 12,
				cursor: 'pointer',
				background: 'none',
				color: theme.palette.grey[500],
				'&:hover': { background: theme.palette.grey[200] },
				'.MuiSvgIcon-root': { fontSize: 14 },
			}}
		>
			<EndlessBookIcon />
			Book
		</Box>
	</Tooltip>
);
